// @flow strict

import { Button, Empty, Spin, Table, Tag } from 'antd';
import React, { useEffect, useState } from "react";
import { getPaymentInvoices } from '../../api/pricing';

const columns = [
  {
    title: <p className="text-center my-0">Date</p>,
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: (date) => (
      <p className="my-0">{new Date(date).toDateString()}</p>
    ),
  },
  {
    title: <p className="text-center my-0">Amount</p>,
    dataIndex: 'amountTotal',
    key: 'amountTotal',
    render: (amount) => (
      <p className="my-0">{"$" + amount / 100}</p>
    ),
  },
  {
    title: <p className="text-center my-0">Type</p>,
    key: 'type',
    dataIndex: 'type',
    render: (type) => (
      <Tag color="green">
        {type === "invoice.paid" ? "Paid Invoice" : type}
      </Tag>
    ),
  },
  {
    title: <p className="text-center my-0">Action</p>,
    key: 'invoice_pdf',
    dataIndex: 'invoice_pdf',
    render: (link) => (
      <Button href={link} target="_blank" size="middle" className="text-decoration-none">
        Download
      </Button>
    ),
  },
];


function Invoices() {
  const [paymentInvoices, setPaymentInvoices] = useState([]);
  const [fetching, setFetching] = useState(false);

  const getPaymentInvoicesData = async () => {
    setFetching(true);

    try {
      const res = await getPaymentInvoices();
      setPaymentInvoices(res.data.invoices);
    } catch (error) {
      console.log(error)
    } finally {
      setFetching(false);
    };
  };

  useEffect(() => {
    getPaymentInvoicesData();
  }, []);

  return (
    <>
      <Spin spinning={fetching} tip="Loading...">
        {
          paymentInvoices?.length > 0 ?
            <Table
              bordered
              title={() => <h5>Payment Invoices</h5>}
              dataSource={paymentInvoices}
              columns={columns}
              scroll={{
                x: true,
              }}
              tableLayout="auto"
              pagination={{
                position: ["bottomCenter"],
              }}
            />

            :
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <span>
                  No Payment History
                </span>
              }
            />
        }
      </Spin>
    </>
  );
};

export default Invoices;